import produce from 'immer'
import { t } from 'helpers/i18n'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import userGroupActions from 'actions/userGroups'
import Component from 'components/Assets/FormView/SelectNotificationGroup'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(userGroupActions.getOptions({ active: 'Active', ...params })).then((r) =>
        produce(r, (draft) => {
          if (params.pageIndex <= 1 && !params.search) {
            draft.value.data.items.unshift({ id: '', description: t('none') })
            draft.value.data.recordCount++
          }
        })
      ),
  }),
})(Component)
